import React, { useRef, useState } from "react";
import uploadImg from "../../assets/images/upload_img.svg";
import vectorImg from "../../assets/images/vector_upload.svg";

export default function UploadBox({ file, setFile, multiple = false }) {
  const fileRef = useRef(null);
  const [dragActive, setDragActive] = useState(false);

  const handleFile = (e) => {
    const files = e.target.files;
    if (!files) return;

    if (multiple) {
      setFile([...files]); // multiple files
    } else {
      setFile(files[0]); // single file
    }
  };

  const handleDrag = (e) => {
    e.preventDefault();
    e.stopPropagation();

    if (e.type === "dragenter" || e.type === "dragover") {
      setDragActive(true);
    } else if (e.type === "dragleave") {
      setDragActive(false);
    }
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(false);

    const files = e.dataTransfer.files;

    if (multiple) {
      setFile([...files]);
    } else if (files?.[0]) {
      setFile(files[0]);
    }
  };

  const handleReplaceFile = () => {
    setFile(null);
    if (fileRef.current) {
      fileRef.current.value = "";
      fileRef.current.click();
    }
  };

  return (
    <div className="upload_part">
      <input
        type="file"
        ref={fileRef}
        accept="image/*,.pdf"
        onChange={handleFile}
        multiple={multiple}
        hidden
      />

      {!file ? (
        <div
          className={`upload_box ${dragActive ? "drag_active" : ""}`}
          onDragEnter={handleDrag}
          onDragOver={handleDrag}
          onDragLeave={handleDrag}
          onDrop={handleDrop}
        >
          <div className="upload_inner">
            <img src={uploadImg} alt="upload" className="cloud_icon" />

            <div className="desc">
              <p className="drag_text">Select a file or drag and drop here</p>
              <p className="format_text">
                JPG, PNG or PDF, file size no more than 10MB
              </p>
            </div>

            <button
              type="button"
              className="select_btn"
              onClick={() => fileRef.current?.click()}
            >
              SELECT FILE
            </button>
          </div>
        </div>
      ) : (
        <div className="upload_box uploaded_state">
          <p className="upload_title">File added</p>

          <div className="uploaded_box">
            <div className="file_info">
              <div className="path_name">
                <img src={vectorImg} alt="file" className="file_icon" />
                <span className="file_name">
                  {Array.isArray(file)
                    ? `${file.length} files selected`
                    : file.name}
                </span>
              </div>
            </div>

            <button
              type="button"
              className="replace_btn"
              onClick={handleReplaceFile}
            >
              REPLACE FILE
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
